module.exports = __webpack_public_path__ + "img/tailwind.3323dd02.svg";